import { CurrentUserIndexResponse } from "./currentUser";

export interface SessionsCreateParams {
  email: string;
  password: string;
}

export type SessionsCreateResponse = CurrentUserIndexResponse;

export const sessionsCreateQuery = (params: SessionsCreateParams) => ({
  url: "/api/login",
  method: "POST",
  body: { user: params },
});

export const sessionsDestroyQuery = () => ({
  url: "/api/logout",
  method: "DELETE",
});

export const diagnosticSessionsDestroyQuery = () => ({
  url: "/diagnostics/sign_out",
  method: "DELETE",
});

export const impersonationSessionsDestroyQuery = () => ({
  url: "/users/stop_impersonating",
  method: "POST",
});

export interface SessionsAuthenticateWithCheckoutParams {
  session_id: string;
}

export const sessionsAuthenticateWithCheckoutQuery = (
  params: SessionsAuthenticateWithCheckoutParams,
) => ({
  url: "/api/v1/diagnostics/authenticate",
  method: "POST",
  body: params,
});
